export default __webpack_public_path__ + "media/images/temporary/famous-long-2d333b5919a5878466c5f2d51ebcaf07.jpg";